<template>
	<v-row>
		<v-col cols="12" sm="4">
			<v-card height="100%">
				<v-card-title>Struktur</v-card-title>
				<v-card-text>
					<p>Unter Strukturen werden digitale Fähigkeiten und die Verfügbarkeit technischer Ressourcen, Tools, Programme, struktureller Rahmenbedingungen sowie institutionalisierter Funktionen und formaler Regelwerke erfasst, die 
						<ul>
							<li>im klinischen Anwendungsfeld medizinische, pflegerische, therapeutische und administrative Prozesse unterstützen, um- oder neu gestalten;</li>
							<li>eine professionelle Durchführung von Informationsmanagement-Aktivitäten ermöglichen</li>
							<li>im organisatorischen Kontext in Bezug auf digitale Reife partizipative und innovationsfördernde Aktivitäten fördern und eine intelligente Datennutzung sowie die Einhaltung regulatorischer Anforderungen gewährleisten.</li>
						</ul>
					</p>
					<p>
						Themenbereiche sind u.a.:
					</p>
						<ul>
							<li>Interoperabilität, Schnittstellen, Standards</li>
							<li>Mobiler Datenzugriff</li>
							<li>Sektorenübergreifende Vernetzung</li>
							<li>Unterstützende IT-Funktionen, Hardware und Peripherie (z.B. Identifikation, Entscheidungsunterstützung)</li>
							<li>IT-Governance, IT-Budget und IT-Personal</li>
							<li>Informationsmanagement-Tools</li>
							<li>Informationssicherheit / IT-Compliance</li>
							<li>Vorschlagswesen & Austausch zwischen Klinikern und IT</li>
							<li>Data Science-Funktionen und -strukturen</li>
							<li>Externe und interne Richtlinien / Gesetzgebung</li>
						</ul>
				</v-card-text>
			</v-card>
		</v-col>
		<v-col cols="12" sm="4">
			<v-card height="100%">
				<v-card-title>Prozess</v-card-title>
				<v-card-text>
					<p>
Unter Prozesse wird erfasst, in welchem Umfang Informationstechnologie zur Unterstützung medizinischer, pflegerischer, therapeutischer und administrativer Prozesse genutzt wird, inwiefern formalisierte Informationsmanagementaktivitäten auf strategischer, taktischer und operativer Ebene die Entwicklung und nachhaltige Umsetzung digitaler Reife (einer Digitalisierungsstrategie) fördern, partizipative Aktivitäten zur Optimierung des Informationssystems durchgeführt und verfügbare Daten intelligent genutzt werden.					</p>
					<p>Themenbereiche sind u.a.: </p>					
						<ul>
							<li>Aufnahme, Überleitung, Entlassung, insbesondere Kommunikation mit externen Leistungserbringern und Patienten</li>
							<li>Leistungsanforderung, -durchführung und Ergebnisrückmeldung</li>
							<li>Medikation OP (Planung, Vorbereitung, Dokumentation, Bericht)</li>
							<li>Querschnitts- und Versorgungsprozesse (z.B. Abrechnung, Belegung, Material, Personal)</li>
							<li>IT-Projektportfolio- & Innovations-Management</li>
							<li>Support: Anwenderschulung, Help-Desk, Problemlösung </li>
							<li>Wartung, Instandhaltung, Disaster Recovery</li>
							<li>Strategisches IT-Monitoring & Evaluation</li>
							<li>Risikomanagement </li>
							<li>Partizipative Aktivitäten bei IT-Projekten, Aktive Vermittlung zw. IT und Fachbereichen</li>
							<li>Innovative Datenanalysen, Process Mining für Forschung und Controlling</li>
						</ul>
				</v-card-text>
			</v-card>
		</v-col>
		<v-col cols="12" sm="4">
			<v-card height="100%">
				<v-card-title>Ergebnis</v-card-title>
				<v-card-text>
					<p>Im Teil Ergebnisse wird erfasst, inwiefern die genutzten Informationssysteme von den Anwendern vor dem Hintergrund der einrichtungs- und bereichsspezifischen Erfordernisse als nützlich und nutzenstiftend eingeschätzt werden, ein sicheres, stets innovatives (agiles) und performantes Informationssystem besteht, und inwiefern eine ausgeprägte Innovationskultur besteht, die die Entwicklung und nachhaltige Umsetzung digitale Reife fördert. </p>
					<p>Themenbereiche sind u.a.: </p>
					<ul>
						<li>Anwenderzufriedenheit hinsichtlich: Benutzerfreundlichkeit, Informationsversorgung, Prozessunterstützung </li>
						<li>Eingeschätzte Nützlichkeit / Nutzenerschließung </li>
						<li>Agilität, Anpassungsfähigkeit </li>
						<li>Anwenderorientierung</li>
						<li>Business Continuity</li>
						<li>Informationssicherheit</li>
						<li>Serviceleistung der IT</li>
						<li>Wirtschaftlichkeit & Erfolg digitaler Projekte</li>
						<li>Nachweisbare Innovationskultur</li>
						<li>Strategisches Alignment</li>
						<li>Business Intelligence, Lernende Organisation</li>
						<li>Realisierter Nutzen für die Organisation (Zeit, Geld, Sicherheit)</li>
					</ul>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"